import React, { useState, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Noti from "../../../util/noti";
import { useUser } from "../../../util/user";
import GYAxios from "../../../util/GYAxios";

import "./style.css";
import SiteCreationNav from "./SiteCreationNav";
import { useRouteWithData } from "../../../util/router";

const EXCEL_DOWNLOAD_ROLES = ['administration:SiteCreation:_generateConsInfo'];

function SiteCreationChild(props) {
	const user = useUser();
	const siteView = user.roles.includes("administration:SiteCreation:_view");
	const siteLicense = user.roles.includes("administration:SiteCreation:_license");
	const siteAdmin = user.roles.includes("administration:SiteCreation:_admin");
	const siteCons = user.roles.includes("administration:SiteCreation:_editCons");
	const consApproval = user.roles.includes("administration:SiteCreation:_approvalCons");
	const permissions = { siteView, siteLicense, siteAdmin, siteCons, consApproval };

const canDownloadExcel = EXCEL_DOWNLOAD_ROLES.some((r) => user.roles.includes(r));
	const [downloading, setDownloading] = useState(false);

	const generateExcel = async () => {
		setDownloading(true);
		try {
			const response = await GYAxios.get("/site_creation/generate-template", {
				responseType: "blob",
				timeout: 60000, // 60 seconds timeout
			});
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const a = document.createElement("a");
			a.href = url;
			a.download = "site_creation_template.xlsx";
			document.body.appendChild(a);
			a.click();
			a.remove();
			window.URL.revokeObjectURL(url);
			Noti.create({ type: "s", msg: "Template downloaded." });
		} catch (err) {
			Noti.create({ type: "e", msg: "Failed to download template." });
		} finally {
			setDownloading(false);
		}
	};

	const requiredRoles = props.requiredRoles;

	const { openLink } = useRouteWithData();

	const hideNavBar = props.hideNavBar;
	const showConsActionBtn = props.showConsActionBtn;

	if(!requiredRoles.every(role => user.roles.includes(role))) {
		return <p><b>Access Denied</b>: You don't have permission to view this content</p>;
	}

	return (
		<Container fluid id="siteCreation">
			<div>
				<h3 id="sc-h3">SITE CREATION</h3>

				{showConsActionBtn && (
					<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
						{siteCons && (
								<button
									className="btn btn-primary"
									onClick={e => openLink(e, "/solar/administration/site-creation/manage-site/construction-form", {})}
									style={{ marginBottom: "10px" }}
								>
									NEW SITE <i className="glyphicon glyphicon-plus"></i>
								</button>
						)}
						{canDownloadExcel && (
								<button
									className="btn btn-default"
									onClick={generateExcel}
									disabled={downloading}
									style={{ marginBottom: "10px" }}
								>
									{downloading ? "Downloading…" : "Generate Construction Excel"}{" "}
									<i className="glyphicon glyphicon-download-alt"></i>
								</button>
						)}
					</div>
				)}

				{!hideNavBar && <SiteCreationNav permissions={permissions} />}

				<div>
					{props.children}
				</div>

			</div>

			<Noti />
		</Container>
	);
}

export default SiteCreationChild;
